import { render, staticRenderFns } from "./ProjectGroups.vue?vue&type=template&id=28b024a2&scoped=true&lang=pug"
import script from "./ProjectGroups.vue?vue&type=script&lang=js"
export * from "./ProjectGroups.vue?vue&type=script&lang=js"
import style0 from "./ProjectGroups.vue?vue&type=style&index=0&id=28b024a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b024a2",
  null
  
)

export default component.exports